/**
 * Chat Control Event Constants
 *
 * These constants define control events used for special DirectLine messages
 * that trigger specific backend behaviors without creating agent turns.
 *
 * Control events are sent in activity.channelData.control_event when
 * message_type is "control".
 */

// Bootstrap control event - initializes a new conversation/project
export const CONTROL_EVENT_BOOTSTRAP = "bootstrap";

// Health probe control event - minimal ping to verify DirectLine channel readiness
export const CONTROL_EVENT_HEALTH_PROBE = "health_probe";

// Health acknowledgement - backend confirms health probe received
export const CONTROL_EVENT_HEALTH_ACK = "health_ack";

/**
 * channelData Schema for Control Messages
 *
 * BOOTSTRAP:
 * {
 *   message_type: "control",
 *   control_event: "bootstrap",
 *   username: string,
 *   user_email: string,
 *   mcp_environment: "primary" | "secondary",
 *   data_version: number,
 *   project_id?: string  // Optional - for rehydrating existing project
 * }
 *
 * HEALTH_PROBE:
 * {
 *   message_type: "control",
 *   control_event: "health_probe"
 * }
 *
 * HEALTH_ACK:
 * {
 *   message_type: "control",
 *   control_event: "health_ack"
 * }
 */
